<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
  *ngIf="loadingEventsCount > 0"
  class="wrapper fixed inset-0"
  style="z-index: 10000">
  <div class="w-full h-full flex items-center justify-center">
    <div
      class="bg-blue bg-opacity-50 w-[300px] h-16 flex items-center justify-center rounded-full">
      <span class="loader block"></span>
    </div>
  </div>
</div>
<div
  class="flex flex-col items-stretch md:justify-stretch min-h-screen overflow-y-scroll md:flex-row">
  <div
    class="md:w-5/12 h-auto glass-morphism-black md:bg-transparent overflow-y-scroll md:overflow-hidden
     bottom-0 absolute md:h-screen md:sticky glass-morphism-black top-0 w-full overflow-hidden md:rounded-tr-4xl z-modal-backdrop {{
      !isVisibleSideInfo ? '-left-full' : 'left-0'
    }}">
    <div
      appClickOutside
      (clickOutside)="clickedOutside()"
      class="h-auto md:h-full min-h-screen w-full md:rounded-tr-4xl banner-healthcare relative">
      <div
        class="h-full min-h-screen w-full flex flex-col items-start justify-between md:rounded-tr-4xl gap-8 px-8 glass-morphism-black py-6">
        <a
          [href]="
            currentLanguage === L.EN
              ? 'https://www.kimbocare.com/'
              : 'https://www.kimbocare.com/fr/'
          "
          target="_blank"
          class="hidden md:block w-[200px] mb-8">
          <img appImg src="assets/svg/logo-white-turquoise.svg" alt="logo"
        /></a>

        <div
          class="flex flex-col items-start gap-8 text-white justify-items-center">
          <span class="text-4xl font-bold xs:leading-[50px] mb-6">{{
            'hcp-registration.greeting-title' | translate
          }}</span>
          <span
            class="text-lg font-semibold text-start greeting-text"
            [innerHTML]="
              'sign-in.spend_wisely_stress_less_care_more' | translate
            "></span>
          <div
            class="w-full h-auto flex items-center justify-center relative mt-2">
            <div class="w-full h-auto">
              <ul class="text-white">
                <li class="flex items-start justify-start gap-3 mb-3">
                  <i class="ri-hospital-line text-3xl"></i>
                  <span
                    [innerHTML]="'sign-in.make_your_selection' | translate"
                    class="text-lg"></span>
                </li>
                <li class="flex items-start justify-start gap-3 mb-3">
                  <i class="ri-user-add-line text-3xl"></i>
                  <span
                    [innerHTML]="'sign-in.name_your_beneficiary' | translate"
                    class="text-lg"></span>
                </li>
                <li class="flex items-start justify-start gap-3 mb-3">
                  <i class="ri-hand-heart-line text-3xl"></i>
                  <span
                    [innerHTML]="'sign-in.give_care' | translate"
                    class="text-lg"></span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <a
          *ngIf="!xlReached"
          (click)="closeSideInfoPanel()"
          style="box-shadow: rgba(0, 168, 147, 0.36) 0rem 0.625rem 1.875rem"
          class="flex mx-auto items-center justify-center text-lg font-semibold tracking-wider text-center text-white bg-transparent bg-no-repeat rounded-full cursor-pointer px-11 h-14 bg-kimbo-gradient bg-origin-padding bg-clip-padding">
          {{ 'sign-in.2fa-submit-button' | translate }}
          <mat-icon class="ml-2">arrow_forward</mat-icon>
        </a>

        <div
          class="hidden md:block pt-5 text-white flex-col items-start text-sm">
          <div class="flex flex-col items-start pr-1 mt-2 mb-4">
            <a
              class="flex items-center text-sm font-semibold tracking-wide text-white hover:underline focus:outline-none focus:shadow-lighter-blue"
              [href]="'common.terms-and-conditions-link-url' | translate"
              rel="noreferrer noopener"
              target="_blank">
              <mat-icon class="mr-1">link</mat-icon>
              {{ 'common.terms-and-conditions-link' | translate }}
            </a>
            <a
              class="flex items-center mt-2 text-sm font-semibold tracking-wide text-white hover:underline focus:outline-none focus:shadow-lighter-blue"
              [href]="'common.privacy-policy-link-url' | translate"
              target="_blank"
              rel="noreferrer noopener">
              <mat-icon class="mr-1">link</mat-icon>
              {{ 'common.privacy-policy-link' | translate }}
            </a>
          </div>
          <span class="text-sm text-white">KimboCare v{{ appVersion }}</span>
        </div>
      </div>
    </div>
  </div>
  <div
    class="md:w-7/12 bg-pattern flex flex-col justify-between md:justify-center items-center">
    <div
      class="w-full flex flex-wrap items-center justify-end my-4 md:py-0 pl-4 pr-1 md:pr-10">
      <app-language-select caller="_LOGIN"></app-language-select>
    </div>

    <div class="w-full px-10 pb-8 md:pb-0">
      <div class="w-full max-w-[450px] mx-auto mb-4"></div>
      <div
        class="flex items-center justify-center w-full max-w-[450px] mx-auto">
        <app-login
          class="w-full block"
          caller="LOGIN_PAGE"
          [addData]="queryParam"></app-login>
      </div>
    </div>
    <div
      class="md:hidden w-full flex flex-col items-center md:mt-16 md:items-start md:justify-center bg-light-gray p-6">
      <a
        class="text-sm font-semibold tracking-wide outline-none text-blue hover:opacity-75 focus:shadow-blue"
        [href]="'common.terms-and-conditions-link-url' | translate"
        target="_blank"
        >{{ 'common.terms-and-conditions-link' | translate }}</a
      >
      <a
        class="inline-block mt-6 text-sm font-semibold tracking-wide outline-none text-blue hover:opacity-75 focus:shadow-blue md:mt-4"
        [href]="'common.privacy-policy-link-url' | translate"
        target="_blank"
        >{{ 'common.privacy-policy-link' | translate }}</a
      >
    </div>
  </div>
</div>
